import React from 'react';
import PropTypes from 'prop-types';

import { withPolaris } from 'Components/protons/Polaris';

import { ArticleGroup } from 'Components/organisms/ArticleGroup';

import './_style.scss';

const EnhancedIndexBlock = ({
  articleCardProps,
  content,
  context: {
    cssPrefix,
  },
  subtitle,
  title,
}) => {
  const hasContent = Array.isArray(content) && content.length > 0;
  if (!hasContent) {
    return null;
  }

  return (
    <div className={`${cssPrefix}__enhanced-index-block`}>
      <div className={`${cssPrefix}__enhanced-index-block__meta`}>
        <p className="-enhanced-title">
          {title}
        </p>
        <p className="-enhanced-subtitle">
          {subtitle}
        </p>
      </div>
      <ArticleGroup
        articleCardProps={articleCardProps}
        articleCardStyle="enhanced-index-block"
        content={content}
        extraClassNames={{
          '-enhanced-index-block': true,
        }}
      />
    </div>
  );
};

EnhancedIndexBlock.propTypes = {
  articleCardProps: PropTypes.shape(),
  content: PropTypes.arrayOf(PropTypes.shape()),
  context: PropTypes.shape(),
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

EnhancedIndexBlock.defaultProps = {
  articleCardProps: {
    isHeading: false,
  },
  content: [],
  context: {
    cssPrefix: 'polaris',
  },
  title: '',
  subtitle: '',
};

export default withPolaris(EnhancedIndexBlock);
